var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockclosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M14.1 19.4v-5.2c0-4.6 3-8.3 6.8-8.3 1.9 0 3.6.9 4.8 2.4 1.2 1.5 2 3.6 2 5.9v5.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M24.3 36.7c4.3 0 7.9-4.5 7.9-10v-7.1H10.3v7.1c0 5.5 3.5 10 7.9 10h6.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockclosed);
export default __webpack_public_path__ + "static/media/lockclosed.03361adb7e949adc4d139cebcfb90787.svg";
export { ForwardRef as ReactComponent };